import { Appearance } from '@/types';

export const getPrintTypesOfAppearance = (appearance: Appearance) => appearance.printTypes;
